// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1Zukj","col":"styles_col__Bi4J-","fulfillmentStatus":"styles_fulfillmentStatus__pvQhM","emailCol":"styles_emailCol__3cNzm"};